var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-pager"},[_c('div',{staticClass:"detail"},[_c('div',{staticClass:"inner"},[_c('div',{staticClass:"name"},[_vm._v("总量趋势")]),_c('div',{staticClass:"chart",attrs:{"id":"chart1"}}),_c('div',{staticClass:"chart",attrs:{"id":"chart2"}}),_c('div',{staticClass:"chart",attrs:{"id":"chart3"}})])])])
}]

export { render, staticRenderFns }